import React from "react";

export function SignupSuccess({ goToLoginPage, clearIsDone }) {
  const handleOk = () => {
    clearIsDone();
    goToLoginPage();
  };
  return (
    <>
      <div className="tw-space-y-6">

        <p className="tw-text-center tw-text-lg tw-font-semibold tw-text-gray-900">
          Thank you for signing up!
        </p>

        <p className="tw-text-center tw-text-base tw-text-gray-900">
          We've sent you an email with the link to activate your account.
        </p>
  
        <button
          className="tw-flex tw-w-full tw-rounded-md tw-bg-blue-500 tw-justify-center tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-text-white tw-shadow-xs hover:tw-bg-blue-400 focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-blue-500"
          type="button"
          onClick={handleOk}
        >
          Ok
        </button>
      </div>
    </>
  );
}
